import React from 'react';

interface Props {
	fallback: (props: { error: Error; errorInfo?: React.ErrorInfo }) => JSX.Element;
	onError?: (error: Error, errorInfo: React.ErrorInfo) => any;
}

interface State {
	hasError: boolean;
	error?: Error;
	errorInfo?: React.ErrorInfo;
	fallbackComponent?: JSX.Element;
}

export default class PureErrorBoundary extends React.Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		this.props.onError?.(error, errorInfo);
		this.setState({
			hasError: true,
			error,
			errorInfo,
			fallbackComponent: this.props.fallback({ error, errorInfo })
		});
	}

	render() {
		if (this.state.hasError) {
			return this.state.fallbackComponent || null;
		}

		return this.props.children;
	}
}
